/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureDiskSettings } from '../models/AzureDiskSettings';

export class AzureDiskTarget {
  /**
  * Region to restore to.
  */
  'region': string;
  /**
  * Name of the resource group to restore to.
  */
  'resourceGroupName': string;
  'settings': AzureDiskSettings;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "settings",
      "baseName": "settings",
      "type": "AzureDiskSettings",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDiskTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

